export default __webpack_public_path__ + "static/media/appstore.4af72c23.png";